/**
 * Chuyển 8 chữ số "ddmmyyyy" gõ trong ô ngày kiểu Việt thành "yyyy-mm-dd". Khoảng năm tuỳ việc:
 * hạn gói 2000–2100 (mặc định), ngày sinh 1920 → năm nay (ui-critic vòng 14: dùng chung một luật
 * làm "25/09/1995" bị báo sai).
 */
export function ngayTuChuSo(
  so: string,
  khoang: { tuNam: number; denNam: number } = { tuNam: 2000, denNam: 2100 },
): string | null {
  if (!/^\d{8}$/.test(so)) return null
  const d = Number.parseInt(so.slice(0, 2), 10)
  const m = Number.parseInt(so.slice(2, 4), 10)
  const y = Number.parseInt(so.slice(4, 8), 10)
  if (y < khoang.tuNam || y > khoang.denNam || m < 1 || m > 12 || d < 1) return null
  // Số ngày của tháng: ngày 0 của tháng sau (tính bằng số, không phân tích chuỗi).
  const soNgay = new Date(Date.UTC(y, m, 0)).getUTCDate()
  if (d > soNgay) return null
  return `${so.slice(4, 8)}-${so.slice(2, 4)}-${so.slice(0, 2)}`
}
